// 报表
import fetch from '@/common/utils/ftFetch'

const baseName = "/ylwebsqsserviceonline"
const moduleList = {
    serviceProvider: `${baseName}/serviceProvider`,
    skillGroup: `${baseName}/skillGroup`,
    customerStaffManager: `${baseName}/customerStaffManager`,
    customerChatRecord: `${baseName}/customerChatRecord`,
    customerChatRecord: `${baseName}/customerChatRecord`,
    file: `${baseName}/file`
}

export const ImApi = {
    // 服务商名称
    queryProvider() {
        return fetch.get(`${moduleList.serviceProvider}/getConditionList`)
    },
    // 列表
    reqList(params) {
        return fetch.post(`${moduleList.skillGroup}/page`, params)
    },
    // 客服姓名
    queryAgentOptions() {
        return fetch.post(`${moduleList.customerStaffManager}/getConditionList`)
    },
    // 会话详情
    queryDetail(id) {
        return fetch.get(`${moduleList.customerChatRecord}/getChatRecord?sessionId=${id}`)
    },
    // 获取图片地址
    getImgUrl(keys) {
        return fetch.get(`${moduleList.file}/getImgUrlBatch?keys=${keys}`)
    },
    // 获取技能组信息
    getSkillAll() {
        return fetch.get(`${moduleList.skillGroup}/selectAll`)
    }
}
